import { render, staticRenderFns } from "./EmbedComponent.vue?vue&type=template&id=6f48929a"
import script from "./EmbedComponent.vue?vue&type=script&lang=js"
export * from "./EmbedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports